import FormulaLabel from "../FormulaLabel/FormulaLabel";
import { FormulaSelect } from "../FormulaSelect";

const VariableComponent = ({
  node,
  dropdownData,
  onSelectHandler,
  onUpdateItem,
  onDeleteItem,
  isActive,
}) => {
  const onSelect = (item) => {
    onSelectHandler(item, { currentNodeId: node.id });
  };

  const renderEndInput = node.valueType === "number";

  return (
    <>
      <FormulaLabel key={node.key} onDeleteItem={onDeleteItem} onUpdateItem={onUpdateItem} node={node} />

      {renderEndInput ? (
        <FormulaSelect
          isActive={isActive}
          onSelectItem={onSelect}
          dropdownData={dropdownData}
        />
      ) : null}
    </>
  );
};

export default VariableComponent;
